import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import fieldErrorAndHelperText from '../utils/fieldErrorAndHelperText';
/**
 * Komponenta checkboxu, nebo switche.
 */

function CheckboxField(_ref) {
  var children = _ref.children,
      error = _ref.error,
      helperText = _ref.helperText,
      InputLabelProps = _ref.InputLabelProps,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, ["children", "error", "helperText", "InputLabelProps", "label"]);

  var _fieldErrorAndHelperT = fieldErrorAndHelperText({
    error: error,
    helperText: helperText,
    label: label
  }),
      _fieldErrorAndHelperT2 = _slicedToArray(_fieldErrorAndHelperT, 2),
      isError = _fieldErrorAndHelperT2[0],
      helperTextOrErrorMessage = _fieldErrorAndHelperT2[1];

  return /*#__PURE__*/React.createElement(FormControl, _extends({}, rest, {
    error: isError
  }), label && /*#__PURE__*/React.createElement(InputLabel, InputLabelProps, label), children, helperTextOrErrorMessage && /*#__PURE__*/React.createElement(FormHelperText, null, helperTextOrErrorMessage));
}

CheckboxField.propTypes = {
  children: PropTypes.node,

  /**
   * Jmeno CSS tridy.
   */
  className: PropTypes.string,

  /**
   * `true` pokud ma byt field disablovan.
   */
  disabled: PropTypes.bool,

  /**
   * Chybova hlaska.
   */
  error: PropTypes.string,
  fullWidth: PropTypes.bool,

  /**
   * Pomocny text, zobrazovany pod `input`em.
   */
  helperText: PropTypes.string,

  /**
   * `Object` s custom vlastnostmi komponenty `InputLabel`.
   */
  InputLabelProps: PropTypes.shape({}),

  /**
   * Zobrazovany label.
   */
  label: PropTypes.string,

  /**
   * Margin fieldu.
   */
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),

  /**
   * `true` pokud ma byt field vyzadovan. Pokud je `true`, automaticky se do labelu prida '*'.
   */
  required: PropTypes.bool,

  /**
   * Objekt stylu.
   */
  style: PropTypes.shape({})
};
CheckboxField.defaultProps = {
  children: null,
  className: undefined,
  disabled: undefined,
  error: undefined,
  fullWidth: undefined,
  helperText: undefined,
  InputLabelProps: undefined,
  label: undefined,
  margin: 'dense',
  required: undefined,
  style: undefined
};
export default CheckboxField;